import axios, { AxiosResponse } from 'axios';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

import { ISezudalostiKorporatniAkce } from './prehledKorporatniAkce';

export interface IKorporatniAkce extends ISezudalostiKorporatniAkce {
    id: number;
    isin: string;
    nazevemise: string;
    datumzverejneni: Date;
    rozhodnyden: Date;
    typudalosti: ETypUdalosti;
    vypis: 'ODESLANO' | 'HOTOVO';
    sezakci: ISezakciKorporatniAkce[];
}
export interface ISezakciKorporatniAkce {
    id: number;
    typudalosti: ETypUdalosti;
    tmp: string;
    nazevsouboru: string;
    datumzalozeni: Date;
    datumzverejneni: Date;
    subject: string;
    potvrzeno: boolean;
}
const korporatniAkceApi = (id: string) => {
    return axios({
        method: 'GET',
        url: `SRD/${id}`
    }).then((resp: AxiosResponse<IKorporatniAkce>) => resp.data);
};
export default korporatniAkceApi;
